export const neckSpurlingText = {
  values: [
    { value: 'NeckSpurling', text: 'Ja', score: 1 },
    { value: 'NeckSpurling', text: 'Nei', score: 0 },
    { value: 'NeckSpurling', text: 'Ikke aktuelt', score: -1 },
  ],
};
